import { omitBy, isNil } from 'lodash'

export const removeNilEventRowsFields = (eventRows) =>
  eventRows.map((row) => (
    { ...removeNilFields(row), debit_account_id: row.debit_account_id, credit_account_id: row.credit_account_id })
  )

export const removeNilFields = (data) => omitBy(data, isNil)
